import React from "react";
import BusinessLayout from "../../layouts/BusinessLayout";
import OrganizationAboutPage from "../../components/organization/OrganizationAboutPage";

const BusinessAboutUs: React.FC = () => {
  return <BusinessLayout>{(business) => <OrganizationAboutPage business={business} />}</BusinessLayout>;
};

export default BusinessAboutUs;
